import { useContext } from 'react'
import { AuthenticationContext } from '../../providers/authentication-provider'

export const useAuth = () => {
  return useContext(AuthenticationContext)
}
